
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu",
      function () {
        return require("private-next-pages/menu.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu"])
      });
    }
  